import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class Tag extends Component {

  @tracked selected1 = false;
  @tracked selected2 = true;

}
